module.exports = __webpack_public_path__ + "img/logo.76a1a313.png";